/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseManagementRepositoryResponse } from "../types/CourseManagementRepositoryResponse.ts";

export const courseManagementRepositoryResponseSchema = z.object({
  courseId: z.optional(z.number().int().describe("ID do curso.")),
  courseName: z.string().describe("Nome oficial do curso.").nullish(),
}) as unknown as ToZod<CourseManagementRepositoryResponse>;
